export default {
  widgets: [],
  tasks: [],
  dates: [],
  tasksUpdated: true,
  datesUpdated: true
};
